export const timeFrameMapping = {
  last24Hours: 'Last 24 Hours',
  last7Days: 'Last 7 Days',
  last30Days: 'Last 30 Days',
};

export const widgetComponents = {
  w: 3,
  endpoint: '/devices',
  advancedEndpoint: '/devices',
  component: 'firewallSummary',
  preview: 'horizontalBarChartPreview',
  timeFrameOptions: [
    timeFrameMapping.last24Hours,
    timeFrameMapping.last7Days,
    timeFrameMapping.last30Days,
  ],
  groupByOptions: [
    'data sent',
    'data received',
    'virus',
    'intrusion',
    'spyware',
  ],
  disableTimeFrameDropdown: false,
};
